import React from "react";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import { useTranslation } from "react-i18next";

export function UnderlineTabs({ desc, curriculum }) {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = React.useState("about");

  const isRTL = i18n.language === "pr" || i18n.language === "ps";
  const alignmentClass = isRTL ? "text-right" : "text-left";

  return (
    <Tabs value={activeTab} className="mb-12 mt-16">
      <TabsHeader
        className="rounded-none border-b border-blue-gray-50 bg-transparent p-0"
        indicatorProps={{
          className:
            "bg-transparent border-b-2 border-indigo-500 shadow-none rounded-none",
        }}
      >
        <Tab
          value="about"
          onClick={() => setActiveTab("about")}
          className={
            activeTab === "about"
              ? "text-indigo-500 text-xs md:text-xl font-bold"
              : "text-xs md:text-lg font-bold"
          }
        >
          {t("About-this-Course")}
        </Tab>
        <Tab
          value="curriculum"
          onClick={() => setActiveTab("curriculum")}
          className={
            activeTab === "curriculum"
              ? "text-indigo-500 text-xs md:text-xl font-bold"
              : "text-xs md:text-lg font-bold"
          }
        >
          {t("Course-Curriculum")}
        </Tab>
      </TabsHeader>

      <TabsBody>
        <TabPanel value="about">
          <div
            className={`text-sm ${alignmentClass}`}
            dangerouslySetInnerHTML={{ __html: desc?.[i18n.language] }}
          />
        </TabPanel>
        <TabPanel value="curriculum">
          <div
            className={`text-sm ${alignmentClass}`}
            dangerouslySetInnerHTML={{ __html: curriculum?.[i18n.language] }}
          />
        </TabPanel>
      </TabsBody>
    </Tabs>
  );
}
